var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Modal', {
    attrs: {
      "modalVisible": _vm.modal,
      "width": "500px",
      "id": "confirm-cancel-order-modal"
    },
    on: {
      "close": _vm.toggle
    }
  }, [_c('div', {
    staticClass: "text-left text-black",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('p', {
    staticClass: "text-3xl font-extrabold mb-4"
  }, [_vm._v("Pesanan ini sedang dalam pengajuan pembatalan")]), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("Mohon tunggu hinga proses verifikasi selesai. Anda akan menerima notifikasi setelah pembatalan dikonfirmasi ")])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }